module.exports = __webpack_public_path__ + "media/sheen.3d641db2.mp3";